import React, { useEffect } from 'react';
import styled from 'styled-components';
import { VerticalGroup, Text, HorizontalGroup, Icon } from '@libs/uikit/Components';

const PopupWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    background: #fff;
    margin: 16px 32px;
    padding: 16px 139px 16px 16px;
    opacity: 0.98;
    border-radius: 4px;
    box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.25);
    border: solid 1px #0a9393;
    z-index: 1002;
    & div {
        margin: 0;
    }
`;

export const Popup = ({ children, onClose }) => {
    useEffect(() => {
        setTimeout(onClose, 3000);
    }, []);
    return (
        <PopupWrapper>
            <HorizontalGroup>
                <Icon name="success" style={{ color: '#0a9393' }} />
                <VerticalGroup>
                    <Text caption>Success!</Text>
                    <Text info>{children}</Text>
                </VerticalGroup>
            </HorizontalGroup>
        </PopupWrapper>
    );
};
